(() => {
    //smooth scroll to open positions
    const scrollBtn = document.querySelector('#scroll-btn');
    const openPositions = document.querySelector('#job-openings-container');
    if (scrollBtn && openPositions) {
        scrollBtn.addEventListener('click', e => {
            e.preventDefault();
            const scrollTo = openPositions.getBoundingClientRect().top + window.pageYOffset - 72;
            window.scrollTo({
                top: scrollTo,
                behavior: 'smooth',
            });
        });
    }

    // slider
    const swiper = new Swiper('.swiper-container', {
        speed: 400,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // tabs
    const tabsTab = document.querySelectorAll('.tabs-tab');
    const tabsContent = document.querySelectorAll('.tabs-content');
    tabsTab.forEach(tab => {
        tab.addEventListener('click', e => {
            e.preventDefault();

            // remove active class for tab
            tabsTab.forEach(activeTab => {
                activeTab.classList.remove('active');
            });

            // remove active class for tab content
            tabsContent.forEach(activeTab => {
                activeTab.classList.remove('active');
                // add active class to active tab content
                if (e.currentTarget.dataset.tab === activeTab.dataset.tab) {
                    activeTab.classList.add('active');
                }
            });
            e.currentTarget.classList.add('active');
        });
    });
})();
